import { pageNote } from './pageNote';
import { PageImageNote } from './pageImageNote';
import { PageImage } from './pageImage';

export * from './images';
export { Modal } from './modal';

export enum ContentModuleTypes {
	BOOK = 'cmtBook',
	IMAGE = 'cmtGallery',
	LESSON = 'cmtLesson',//not an actual type
	TEXT = 'cmtText',
	VIDEO = 'cmtVideo',
	BUTTON = 'cmtButton',
	SPLIT = 'cmtSplit',
	EMBEDDED = 'cmtEmbed',
	FORM = 'cmtForm',
}

export enum ContentModuleSubTypes {
	SINGLE = 'cmtImageGallerySingle',
	SLIDESHOW = 'cmtImageGallerySlideShow',
	GRID = 'cmtImageGalleryGrid',
	FILE = 'cmtButtonFile',
	LINK = 'cmtButtonLink'
}

export enum FolderTypes {
	Lesson = 'ftLesson',
	SharedLesson = 'ftSharedLesson',
	Portfolio = 'ftPortfolio',
	MyStudentsPortfolio = 'ftMyStudentsPortfolio',
	MySharedWithMePortfolio = 'ftMySharedWithMePortfolio',
}

export enum ContentModals {
	ADD_VIDEO = 'addVideoModal',
	ADD_BOOK = 'addBookModal',
	ADD_BUTTON = 'addButtonModal',
	IMPORT_CONTENT = 'importContentModal',
	ADD_FORM = 'addFormModal',
}

export enum EVENTS {
	ADD_CONTENT = 'addContent',
	UPDATE_CONTENT = 'updateContent',
	UPDATE_CONTENT_MODULES = 'updateContentModules',
	DELETE_CONTENT = 'deleteContent',

	SET_LESSON = 'setLesson',
	SET_LESSON_ERRORS = 'setLessonErrors',
	SAVE_LESSON = 'saveLesson',
	DELETE_LESSON = 'deleteLesson',

	SET_PORTFOLIO_PAGE = 'setPortfolioPage',
	SAVE_PORTFOLIO_PAGE = 'savePortfolioPage',
	DELETE_PORTFOLIO_PAGE = 'deletePortfolioPage',
}

export const SortingOptions = [
	{ order: 1, text: 'Recently Edited' },
	{ order: 2, text: 'Recently Created' },
	{ order: 3, text: 'Title A - Z' },
	{ order: 4, text: 'Title Z - A' },
];

export interface Account {
	accountID: string;
	firstName: string;
	lastName: string;
	accountRole?: string;
}

export interface AccountAccess {
	accountAccessType: string;
	createdByAccount: Account;
}

export interface AccessAccount {
	account_accountID: string;
	account_firstName: string;
	account_lastName: string;
	account_primaryEmailAddress_emailAddress: string;
	accessType_systemCode: AccessTypeSystemCode;
}

export interface Folder {
	folderID: string;
	title: string;
	calculatedLessonsCount?: number;
	calculatedArchiveLessonsCount?: number;
	calculatedArchiveFoldersCount?: number;
	calculatedPortfoliosCount?: number;
	folderType_systemCode: FolderTypes;
	account_accountID?: string;
	archiveFlag?: boolean;
	archiveFolder_folderID?: string;

	createdDateTime?: string;
	modifiedDateTime?: Date;
	//shared folder
	accountAccess?: AccountAccess;
}

export interface Portfolio {
	portfolioID: string;
	title: string;
	urlTitle: string;
	headerText: string;
	headerThumbnail: string;
	footerText: string;
	portfolioType: string;
}

export interface Lesson {
	lessonID: string;
	title: string;
	description: string;
	lessonType: string;
	publishedFlag: boolean;
	archiveFolder_folderID?: string;
	folder_folderID?: string;
}

export interface ContentModule {
	contentModuleID: string;
	title: string;
}

export interface IResponse<T> {
	data: T;
	errors: Array<any>;
	messages: Array<any>;
	successfulActions: Array<string>;
	failureActions: Array<string>;
}

export interface IPaginated<T> {
	records: Array<T>;
	totalPages: number;
}

export type LessonsAPIResponse = IResponse<IPaginated<Lesson>>;
export type FoldersAPIResponse = IResponse<IPaginated<Folder>>;
export type PortfoliosAPIResponse = IResponse<IPaginated<Portfolio>>;
export type AccessTypeSystemCode = 'accountAccessRead' | 'accountAccessWrite' | 'accountAccessAdminister';

export type SavePageImageNoteResponse = IResponse< { 'pageImageNote': PageImageNote } >;

export interface SavenoteResponse extends IResponse<any> {
	pageNoteID: string;
}


export type FolderAPIResoponse = IResponse<Folder>;

export { 
    pageNote, 
    PageImage,
    PageImageNote 
};
